import actionTypes from 'constants/actionTypes'

type LogoutConfirmState = {
  pendingActions?: {
    actions?: unknown[]
  }
}


export const login = ({ username, password }: { username: string; password: string }) => {
  return {
    type: actionTypes.AUTH.LOGIN,
    payload: {
      username,
      password
    },
    meta: {
      client: 'auth',
      request: 'auth.login'
    }
  }
}

export const signup = ({
  username,
  email,
  password,
  inviteToken
}: {
  username: string
  email: string
  password: string
  inviteToken?: string
}) => {
  return {
    type: actionTypes.AUTH.SIGNUP,
    payload: {
      username,
      email,
      password,
      inviteToken
    },
    meta: {
      client: 'auth',
      request: 'auth.signup'
    }
  }
}

export const logout = () => {
  return {
    type: actionTypes.AUTH.LOGOUT,
    payload: {},
    meta: {
      client: 'auth',
      request: 'auth.logout',
      confirm: (state: LogoutConfirmState) => {
        if ((state.pendingActions?.actions?.length || 0) > 0) {
          return "You'll lose your pending changes if you log out now. Are you sure you want to log out?"
        }
        return null
      }
    }
  }
}

export const mustLogin = ({ returnUrl }: { returnUrl: string }) => {
  return {
    type: actionTypes.AUTH.MUST_LOGIN,
    payload: { returnUrl }
  }
}

export const forgotPassword = ({ username }: { username: string }) => {
  return {
    type: actionTypes.AUTH.FORGOT_PASSWORD,
    payload: { username },
    meta: {
      client: 'auth',
      request: 'auth.forgotPassword'
    }
  }
}

export const resetPassword = ({ password, resetToken }: { password: string; resetToken: string }) => {
  return {
    type: actionTypes.AUTH.RESET_PASSWORD,
    payload: { password, resetToken },
    meta: {
      client: 'auth',
      request: 'auth.resetPassword'
    }
  }
}

export const dismissLoginError = (idx: number) => {
  return {
    type: actionTypes.AUTH.LOGIN.DISMISS_ERROR,
    payload: { idx }
  }
}

export const dismissSignupError = (idx: number) => {
  return {
    type: actionTypes.AUTH.SIGNUP.DISMISS_ERROR,
    payload: { idx }
  }
}

export const dismissResetPasswordError = (idx: number) => {
  return {
    type: actionTypes.AUTH.RESET_PASSWORD.DISMISS_ERROR,
    payload: { idx }
  }
}
